// src/context/LanguageContext.js
import React, { createContext, useEffect, useState } from "react";
import i18next from "i18next";

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [traslate, setTraslate] = useState(
    localStorage.getItem("traslate") === "true"
  );

  const toggleLanguage = () => {
    const newTraslate = !traslate;
    setTraslate(newTraslate);
    localStorage.setItem("traslate", newTraslate);
    i18next.changeLanguage(!newTraslate ? "en" : "es");
  };

  useEffect(() => {
    i18next.changeLanguage(!traslate ? "en" : "es");
  }, [traslate]);

  return (
    <LanguageContext.Provider value={{ traslate, toggleLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};
